import '@vaadin/dialog';
import { css, html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { TmBaseComponent } from '../../tm-base.component';

export const tagName = 'tm-form-row-message-center';
@customElement(tagName)
export class TmFormRowMessageCenter extends TmBaseComponent {
    /**
     * Size of the flex gap between the label and content. Use tailwind classes.
     * */
    @property({ attribute: false })
    public gap = 'gap-4';

    /**
     * String for the Label or use the label slot for custom implementations
     * */
    @property({ attribute: false })
    public label = 'Label';

    /**
     * Classes that will be applied to the outer div of the default label text.
     * Default is 'text-sm font-medium'
     */
    @property({ attribute: false })
    public labelClasses = 'text-sm font-medium';

    /**
     * Should vertically center the label
     * Default: true
     */
    @property({ attribute: false })
    public centerLabel = true;

    @property({ type: Boolean, reflect: true })
    public required = false;

    @property({ attribute: false })
    public noWrap = false;

    @state()
    private hasSummary = false;

    protected render() {
        return html`
            <div class="flex flex-col">
                <div class="flex flex-row justify-between ${this.gap}">
                    <slot name="label">
                        <div
                            class=${classMap({
                                flex: true,
                                [this.labelClasses]: true,
                                'items-center': this.centerLabel,
                                'whitespace-nowrap': this.noWrap,
                            })}
                        >
                            ${this.label}
                        </div>
                    </slot>
                    <slot name="content" class="flex-grow" @slotchange=${this.inputElementChange}>
                    </slot>
                </div>
                <div
                    class=${classMap({
                        'border-dashed': this.hasSummary,
                        'border-t': this.hasSummary,
                    })}
                >
                    <slot name="summary" class="text-right" @slotchange=${this.handleSlotChange}>
                    </slot>
                </div>
            </div>
        `;
    }

    private handleSlotChange(e: Event) {
        if (e.target instanceof HTMLSlotElement) {
            this.hasSummary = e.target?.assignedNodes({ flatten: true }).length > 0;
        }
    }

    private inputElementChange(e: Event) {
        if (!(e.target instanceof HTMLSlotElement)) {
            return;
        }

        e.target.assignedElements().forEach(element => {
            element.classList.add('form-row-slotted');
            element.setAttribute('formRowSlotted', '');
            if (this.required) {
                element.setAttribute('required', '');
            } else {
                element.removeAttribute('required');
            }
        });
    }

    public static get styles() {
        return [
            css`
                :host([dashed]) {
                    border-bottom-style: dashed !important;
                }

                :not([name])::slotted(*) {
                    width: 100%;
                }

                button svg {
                    height: 14px !important;
                    width: 14px !important;
                }
            `,
        ];
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: TmFormRowMessageCenter;
    }
}
